<template>
    <div>
        <div style="padding:20px 0; height:30px; font-size:50px;">
            <b>{{data.Company}}</b>
        </div>
        <br><br><br>

        <div style="padding:20px 0;border-bottom:1px solid #e2e2e2;margin-bottom:20px;">
            <b>About</b>
        </div>
        <div class="html-text-content" v-html="data.About"></div>
        <br><br>
        
        <div style="padding:20px 0;border-bottom:1px solid #e2e2e2;margin-bottom:20px;">
            <b>How it works(graph, functions, video)</b>
        </div>
        <div class="html-text-content" v-html="data.How"></div>
        <br><br>

        <div style="padding:20px 0;border-bottom:1px solid #e2e2e2;margin-bottom:20px;">
            <b>Supported products/Versions</b>
        </div>
        <div class="html-text-content" v-html="data.Supported"></div>
        <br><br>
        
        <div style="padding:20px 0;border-bottom:1px solid #e2e2e2;margin-bottom:20px;">
            <b>Manual</b>
        </div>
        <div class="html-text-content" v-html="data.Manual"></div>
        <br><br>
        
         <div style="float:right;">
                <el-button @click="submit()" type="primary">Close</el-button>
        </div>
    </div>
</template>
<script>

export default {
    components:{  
    },
    props:{
        id:{}
    },
    data () {
        return {
            data:{     
            }
        };
    },
    mounted () {
        this.getInfo();
    },
    methods:{
        getInfo () {
            this.$http.get("getTechnologyPartnerCompanyInfo",{
                TechnologyPartners:this.id
            },(data)=>{
                this.data = data.data;
            });
        },
        submit () { 
            this.$router.push(`/technologyPartners`);
        }
    }
};
</script>
<style lang="less" scoped>
    .html-text-content{
        table td,table th {
            border-bottom: 1px solid #ccc;
            border-right: 1px solid #ccc;
        }
    }
</style>
